<template>
  <div>
    <el-card class="mat12">
      <el-row>
        <el-col :span="6" class="padding-tb10 flex_class media_col" v-if=" project.projectCode">
          <h4 class="flex_shrink">项目编号：</h4>
          <span class="ellipsis" :title="project.projectCode">{{ project.projectCode}}</span>
        </el-col>
        <el-col :span="6" class="padding-tb10 flex_class media_col" v-if=" project.contractCode">
          <h4 class="flex_shrink">合同编号：</h4>
          <div class="start_icon">
            <span class="ellipsis" :title="project.contractCode">{{project.contractCode}}</span>
          </div>
        </el-col>
        <el-col :span="6" class="padding-tb10 flex_class media_col"  v-if=" project.projectName">
          <h4 class="flex_shrink">项目名称：</h4>
          <span class="ellipsis" :title="project.projectName">{{ project.projectName }}</span>
        </el-col>
        <!-- <el-col :span="6" class="padding-tb10 flex_class">
          <h4 class="flex_shrink">制作人：</h4>
          <span  class="ellipsis" :title="project.creater">{{ creater }}</span>
        </el-col>-->
        <el-col :span="6" class="padding-tb10 flex_class media_col address_wrap" @click.native="handleOpenAddress"  v-if=" project.address">
          <h4 class="flex_shrink">项目地址：</h4>
            <span class="ellipsis" :title="project.address">{{ project.address }}</span>
            <i class="el-icon-location"></i>
        </el-col>
        <el-col :span="6" class="padding-tb10 flex_class media_col"  v-if=" project.dept">
          <h4 class="flex_shrink">运营部门：</h4>
          <span class="ellipsis" :title="project.dept">{{ project.dept }}</span>
        </el-col>
        <el-col :span="6" class="padding-tb10 flex_class media_col"  v-if=" project.contact">
          <h4 class="flex_shrink">客户联系人：</h4>
          <span class="ellipsis" :title="project.contact">{{ project.contact }}</span>
        </el-col>
        <el-col :span="6" class="padding-tb10 flex_class media_col"  v-if=" project.phone">
          <h4 class="flex_shrink">联系电话：</h4>
          <span class="ellipsis" :title="project.phone">{{ project.phone }}</span>
        </el-col>
        <el-col :span="6" class="padding-tb10 flex_class media_col"  v-if="project.beginDate">
          <h4 class="flex_shrink">合约期限：</h4>
          <span
            class="ellipsis"
            :title="project.beginDate+'至'+ project.endDate"
            :class="isExpire(project.endDate) == 1 ?'yellow':(isExpire(project.endDate) == 2 ? 'red':'')"
          >{{project.beginDate}}至{{project.endDate}}</span>
        </el-col>
        <el-col :span="6" class="padding-tb10 flex_class media_col"  v-if="project.serviceLevel">
          <h4 class="flex_shrink">服务等级：</h4>
          <div class="start_icon">
            <img :src="startImg" alt v-for="item in project.serviceLevel" :key="item" />
          </div>
        </el-col>
          <el-col :span="6" class="padding-tb10 flex_class media_col" >
          <h4 class="flex_shrink">管理公司：</h4>
          <div class="start_icon ellipsis">
            <span class="ellipsis" :title="getCompanName(project.manageCompanyId)">{{ getCompanName(project.manageCompanyId)}}</span>
          </div>
        </el-col>
          <el-col :span="6" class="padding-tb10 flex_class media_col"  >
          <h4 class="flex_shrink">合同公司：</h4>
          <div class="start_icon ellipsis">
            <span class="ellipsis"  :title="getCompanName(project.contractCompanyId)">{{ getCompanName(project.contractCompanyId)}}</span>
          </div>
        </el-col>
         <el-col  class="padding-tb10 flex_class " v-for="item in participantsList" :key="item.id" v-if="item.name">
          <h4 class="flex_shrink" >{{item.title}}：</h4>
          <span :class="{'ellipsis':$store.state.tagView}" class="white_space">
            {{item.name }}
          </span>
        </el-col>
      </el-row>
    </el-card>
    <!-- 地图弹窗 -->
    <map-ready-dialog
      @cancel="handleCncel"
      :dialogVisible="dialogVisible"
      :center="center"
      :address="project.address"
    ></map-ready-dialog>
  </div>
</template>

<script>
import {
  ContractCompanyList,
} from '@/api/contract'
export default {
  name: 'CardProjectInfo',
  props: {
    dataDesc: {
      type: Object,
      default: {}
    }
  },

  computed: {
    project () {
      return this.dataDesc.project
    }
  },
  data () {
    return {
      startImg: require('@/assets/start.png'),
      dialogVisible: false,
      center: {
        lng: '',
        lat: ''
      },
      ContractList:[], //合同公司
      manageCompanyName:'',
      contractCompanyName:'',
      participantsList: [], // 处理结构
      list:[]
    }
  },
  created () {
    this.center.lng = this.project.lng
    this.center.lat = this.project.lat
    this.getcontractList()
    this.handleParticipantsList()
  },
  methods: {
      // 合同公司
    async getcontractList(){
      let result = await ContractCompanyList({"q":{"companyName":""}})
      if(result.data){
       this.list = result.data

     
      }
    },
    getCompanName(id){
      let str = ''
       this.list.forEach(item=>{
          if(item.id === id){
            str =  item.companyName
          }
        })
        return  str ? str : '无'
    },
    // 处理下参与人的问题
    handleParticipantsList () {
      this.$nextTick(() => {
        let arr = this.dataDesc.project.participantList ? this.dataDesc.project.participantList : this.dataDesc.project.participants
        let flag = this.dataDesc.project.participantList ? 1 : 2
        if (!arr) {
          return
        }
        if (flag === 2) {
          let list = []          
          arr.forEach(item => {
            let newItem = list.find((i) => i.roleType == item.roleType)
            if (!newItem) {
              list.push({
                roleType: item.roleType,
                users: [item.userName]
              })
            } else {
              newItem.users.push(item.userName)
            }
          })

          this.participantsList = list.map(item => {
            if (item.roleType === 0) {
              item.title = '项目负责人'
            } else if (item.roleType === 1) {
              item.title = '市场'
            } else if (item.roleType === 2) {
              item.title = '运营'
            } else if (item.roleType === 3) {
              item.title = '综合服务人员'
            } else if (item.roleType === 4) {
              item.title = '其他人员'
            } else {
              item.title = '其他人员'
            }
            item.name = this.unique(item.users).join()
            return item
          })
        } else {
          this.participantsList = arr.map(item => {
            if (item.roleType === 0) {
              item.title = '项目负责人'
            } else if (item.roleType === 1) {
              item.title = '市场'
            } else if (item.roleType === 2) {
              item.title = '运营'
            } else if (item.roleType === 3) {
              item.title = '综合服务人员'
            } else if (item.roleType === 4) {
              item.title = '其他人员'
            } else {
              item.title = '其他人员'
            }
            // 处理名字显示
            item.name = this.unique(item.names).join()
            return item
          })
        }
      })
    },
    // 处理时间期限
    isExpire (value) {
      let flag = '3' // 默认为3
      let newdDate = new Date().getTime()
      let oldDate = new Date(value).getTime()
      //  差值 转换成天数
      let val = Math.floor((oldDate - newdDate) / 1000 / 60 / 60 / 24)
      if (val <= 45 && val > 30) {
        flag = '1'
      } else if (val <= 30) {
        flag = '2'
      } else {
        flag = '3'
      }
      return flag
    },
    // 展示地图
    handleOpenAddress () {
      this.dialogVisible = true
    },
    // 取消关闭弹窗
    handleCncel (val) {
      this.dialogVisible = val
    },
    // 简单去重
    unique (arr) {
      return Array.from(new Set(arr))
    }
  }
}
</script>

<style lang="scss" scoped>
$color: #409eff;
.start_icon {
  width: 100%;
  img {
    width: 14px;
    height: 14px;
    margin-right: 6px;
  }
}
.red {
  color: #ff0000;
}

.yellow {
  color: #d38b00;
}
.address_wrap {
  cursor: pointer;
  div {
    display: flex;
    align-items: center;
  }
  i {
    color: $color;
  }
}
.white_space{
  white-space: nowrap
}
</style>
